import { createContext, useContext, useReducer } from "react";

// 创建文件参数上下文
const FilesArgContext = createContext(null);

// 创建文件参数 dispatch 上下文
const FilesArgDispatchContext = createContext(null);

// 文件参数提供者组件，用于提供文件参数和 dispatch
export default function FileArgProvider({ children }) {
  // 使用 useReducer 定义文件参数的状态和 dispatch 函数
  const [filesArg, dispatch] = useReducer(filesArgReducer, initialFilesArg);

  return (
    // 提供文件参数的上下文
    <FilesArgContext.Provider value={filesArg}>
      {/* 提供文件参数 dispatch 的上下文 */}
      <FilesArgDispatchContext.Provider value={dispatch}>
        {children}
      </FilesArgDispatchContext.Provider>
    </FilesArgContext.Provider>
  );
}

// 自定义 Hook：用于从文件参数上下文中获取文件参数
export function useFilesArg() {
  return useContext(FilesArgContext);
}

// 自定义 Hook：用于从文件参数 dispatch 上下文中获取 dispatch 函数
export function useFilesArgDispatch() {
  return useContext(FilesArgDispatchContext);
}

// 定义文件参数的 reducer 函数
function filesArgReducer(filesArg, action) {
  switch (action.type) {
    case "changed": {
      // 更新文件参数
      return {
        ...filesArg,
        entries: action.entries,
        product_category: action.product_category,
        series_id: action.series_id,
      };
    }
    default: {
      // 处理未知的 action 类型
      throw Error("Unknown action: " + action.type);
    }
  }
}

// 初始文件参数为空对象
const initialFilesArg = {};
